// @flow
import RoofSnapSearchApiClient from "roofsnap-search-api-client";
import {
    GET_SEARCH_SUGGESTIONS_REQUEST,
    GET_SEARCH_SUGGESTIONS_SUCCESS,
    GET_SEARCH_SUGGESTIONS_FAILURE,
    CLEAR_SEARCH_SUGGESTIONS
} from './actionTypes';
import {CALL_API} from "../middleware/api";
import LocalStorageWrapper from "../lib/localStorageWrapper";

export const getSearchSuggestions = (endpoint: string, search: string, suggesterName: string) => {
    const accessToken = LocalStorageWrapper.getItem('accessToken');
    const apiClientInit = {
        token: accessToken,
        environment: process.env.REACT_APP_ENVIRONMENT,
        apiVersion: '2017-11-11',
    };
    const roofSnapSearchClient = new RoofSnapSearchApiClient(apiClientInit);
    const request = roofSnapSearchClient.getSearchSuggestions;

    return {
        [CALL_API]: {
            types: [
                GET_SEARCH_SUGGESTIONS_REQUEST,
                GET_SEARCH_SUGGESTIONS_SUCCESS,
                GET_SEARCH_SUGGESTIONS_FAILURE
            ],
            request,
            params: {
                endpoint,
                search,
                suggesterName
            }
        }
    }
};

export const clearSearchSuggestions = () => {
    return {
        type: CLEAR_SEARCH_SUGGESTIONS,
    }
};
